import { render, staticRenderFns } from "./RouterForward.vue?vue&type=template&id=64adf9c9"
import script from "./RouterForward.vue?vue&type=script&lang=js"
export * from "./RouterForward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports